import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container hero-content">
        <div className="hero-text fade-in">
          <h1 className="hero-title">
            Building Intelligent <br />
            <span className="highlight">AI Solutions</span>
          </h1>
          <p className="hero-subtitle">
            Developing advanced automation pipelines and scalable architectures <br />
            that drive real business impact.
          </p>
          <div className="hero-cta">
            <button className="primary-btn" onClick={() => document.getElementById('case-studies').scrollIntoView({ behavior: 'smooth' })}>
              View Case Studies
            </button>
          </div>
        </div>
      </div>
      <div className="hero-background-glow"></div>
    </section>
  );
};

export default Hero;
